import _asyncToGenerator from "/app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _toConsumableArray from "/app/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import "regenerator-runtime/runtime.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.filter.js";
import "core-js/modules/es.iterator.map.js";
import "core-js/modules/es.object.to-string.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { setDataAuthority } from '@/api/authority';
export default {
  name: 'Datas',
  props: {
    row: {
      default: function _default() {
        return {};
      },
      type: Object
    },
    authority: {
      default: function _default() {
        return {};
      },
      type: Array
    }
  },
  data: function data() {
    return {
      authoritys: [],
      dataAuthorityId: [],
      needConfirm: false
    };
  },
  created: function created() {
    var _this = this;
    this.authoritys = [];
    this.dataAuthorityId = [];
    this.roundAuthority(this.authority);
    this.row.dataAuthorityId && this.row.dataAuthorityId.map(function (item) {
      var obj = _this.authoritys && _this.authoritys.filter(function (au) {
        return au.authorityId === item.authorityId;
      }) && _this.authoritys.filter(function (au) {
        return au.authorityId === item.authorityId;
      })[0];
      _this.dataAuthorityId.push(obj);
    });
  },
  methods: {
    // 暴露给外层使用的切换拦截统一方法
    enterAndNext: function enterAndNext() {
      this.authDataEnter();
    },
    all: function all() {
      this.dataAuthorityId = _toConsumableArray(this.authoritys);
      this.row.dataAuthorityId = this.dataAuthorityId;
      this.needConfirm = true;
    },
    self: function self() {
      var _this2 = this;
      this.dataAuthorityId = this.authoritys.filter(function (item) {
        return item.authorityId === _this2.row.authorityId;
      });
      this.row.dataAuthorityId = this.dataAuthorityId;
      this.needConfirm = true;
    },
    selfAndChildren: function selfAndChildren() {
      var arrBox = [];
      this.getChildrenId(this.row, arrBox);
      this.dataAuthorityId = this.authoritys.filter(function (item) {
        return arrBox.indexOf(item.authorityId) > -1;
      });
      this.row.dataAuthorityId = this.dataAuthorityId;
      this.needConfirm = true;
    },
    getChildrenId: function getChildrenId(row, arrBox) {
      var _this3 = this;
      arrBox.push(row.authorityId);
      row.children && row.children.map(function (item) {
        _this3.getChildrenId(item, arrBox);
      });
    },
    // 提交
    authDataEnter: function authDataEnter() {
      var _this4 = this;
      return _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var res;
        return regeneratorRuntime.wrap(function (_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.next = 1;
              return setDataAuthority(_this4.row);
            case 1:
              res = _context.sent;
              if (res.code === 0) {
                _this4.$message({
                  type: 'success',
                  message: '资源设置成功'
                });
              }
            case 2:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }))();
    },
    //   平铺角色
    roundAuthority: function roundAuthority(authoritys) {
      var _this5 = this;
      authoritys && authoritys.map(function (item) {
        var obj = {};
        obj.authorityId = item.authorityId;
        obj.authorityName = item.authorityName;
        _this5.authoritys.push(obj);
        if (item.children && item.children.length) {
          _this5.roundAuthority(item.children);
        }
      });
    },
    //   选择
    selectAuthority: function selectAuthority() {
      this.row.dataAuthorityId = this.dataAuthorityId;
      this.needConfirm = true;
    }
  }
};